import { useEffect, useState } from "react";
import { ConditionRowFilter } from "@/frontend/components/FilterV2/model/types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { compressFilter, decompressFilter } from "./filtersEncoding";

function getFiltersFromLocalStorage(searchParams: URLSearchParams, key: string): ConditionRowFilter[] {
  const filters = searchParams.getAll("filter");

  if (filters.length) {
    return filters.map(decompressFilter).filter((f: any) => !!f) as ConditionRowFilter[];
  }

  const serializedFilters = localStorage.getItem(key);
  if (serializedFilters) {
    return JSON.parse(serializedFilters)
      .map(decompressFilter)
      .filter((f: any) => !!f);
  }
  return [];
}

export function getQueryParamsFilters(filters: ConditionRowFilter[]) {
  const serializedFilters = filters.map(compressFilter).filter((filter) => filter !== null) as string[];
  const query = new URLSearchParams();
  serializedFilters.forEach((filter) => query.append("filter", filter));
  return { serializedFilters, query };
}

export function useDiscoverFilters(key: string) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [filters, setFilters] = useState<ConditionRowFilter[]>(getFiltersFromLocalStorage(searchParams, key));

  useEffect(() => {
    const { serializedFilters, query } = getQueryParamsFilters(filters);
    navigate(`?${query.toString()}`, { replace: true });
    localStorage.setItem(key, JSON.stringify(serializedFilters));
  }, [filters]);

  useEffect(() => {
    const filtersFromQuery = getFiltersFromLocalStorage(searchParams, key);
    const strippedFiltersFromQuery = filtersFromQuery.map((f) => {
      const { id, error, filters, ...rest } = f;
      return rest;
    });
    const strippedFilters = filters.map((f) => {
      const { id, error, filters, ...rest } = f;
      return rest;
    });
    if (JSON.stringify(strippedFilters) !== JSON.stringify(strippedFiltersFromQuery)) {
      setFilters(filtersFromQuery);
    }
  }, [searchParams]);

  return { filters, setFilters };
}
